import styled from 'styled-components';

export const ActionsBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: .75rem;

  @media only screen and (max-width: 1200px) {
    justify-content: flex-start;
    padding-left: 70px;
  }
`;
